import { render } from "./disable-common-usernames.vue?vue&type=template&id=66d220af"
import script from "./disable-common-usernames.vue?vue&type=script&lang=js"
export * from "./disable-common-usernames.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__